import { MINI_BUTTON_ACTION_SIZE, MINI_BUTTON_DOCK_GAP } from '@focuslee/shared-mini-app';

export const FLOATING_TABBAR_BOTTOM_INSET = MINI_BUTTON_DOCK_GAP;
export const FLOATING_TABBAR_HORIZONTAL_INSET = MINI_BUTTON_DOCK_GAP;
export const FLOATING_TABBAR_BAR_HEIGHT = MINI_BUTTON_ACTION_SIZE;
export const FLOATING_TABBAR_BAR_GAP = MINI_BUTTON_DOCK_GAP;
export const FLOATING_TABBAR_ACTION_SIZE = MINI_BUTTON_ACTION_SIZE;
export const FLOATING_TABBAR_SATELLITE_SIZE = 36;
export const FLOATING_TABBAR_SATELLITE_GAP = 8;

export const floatingTabbarBlockHeightPx = FLOATING_TABBAR_BAR_HEIGHT + FLOATING_TABBAR_BOTTOM_INSET;

export const floatingTabbarSafeAreaBottom =
    'calc(var(--tg-viewport-content-safe-area-inset-bottom, 0px) + var(--tg-viewport-safe-area-inset-bottom, 0px))';

// Bottom padding scrollable tab content should reserve so its last item clears the floating tabbar.
export const floatingTabbarScrollBottomPad = `calc(${floatingTabbarBlockHeightPx}px + 16px + ${floatingTabbarSafeAreaBottom})`;

// Same, but also clears the voice satellite button (e.g. the chevron toggle) that floats above
// the main tabbar on tabs where it's shown, so scrolled content never stops underneath it.
const floatingTabbarSatelliteClearance = FLOATING_TABBAR_SATELLITE_SIZE + FLOATING_TABBAR_SATELLITE_GAP;
export const floatingTabbarScrollBottomPadWithSatellite = `calc(${
    floatingTabbarBlockHeightPx + floatingTabbarSatelliteClearance
}px + 16px + ${floatingTabbarSafeAreaBottom})`;

// Distance from the viewport bottom to the bottom edge of the satellite row (where the voice
// menu's up-chevron button floats), so other floating elements can align with it.
export const floatingTabbarSatelliteBottomOffset = `calc(${floatingTabbarBlockHeightPx}px + ${FLOATING_TABBAR_SATELLITE_GAP}px + ${floatingTabbarSafeAreaBottom})`;

// Width reserved on the right for the voice action column + satellite chevron above it, so a
// floating block can size itself to sit flush to the left of the chevron.
export const floatingTabbarActionColumnReservedWidth = FLOATING_TABBAR_ACTION_SIZE + FLOATING_TABBAR_BAR_GAP;
